import { SearchScopeKind, type SearchScope } from 'owa-search-service/lib/data/schema/SearchScope';
import type TableQuery from '../store/schema/TableQuery';
import { type TableQueryType } from '../store/schema/TableQuery';
import type TableView from '../store/schema/TableView';

type SearchTableQuery = TableQuery & {
    searchScope?: SearchScope;
};

export function isMultiAccountTable(tableView?: TableView): boolean {
    return (
        tableView?.tableQuery.type === 1 &&
        (tableView.tableQuery as SearchTableQuery).searchScope?.kind ===
            SearchScopeKind.AllMailboxes
    );
}
